import gql from 'graphql-tag';

export default gql`
  fragment ClientInvitation on ClientInvitation {
    id
    client_id
    email_address
    invitation_status
    subject
    message
    email_from_address
    created_at
    updated_at
    last_sent_at
    retries
    accepted_at
    accepted_by_user_id
  }
`;
